import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const ReparationFenetrePVCLyon = lazy(() => import('../pages/reparation-fenetre-pvc-lyon/page'));
const ReparationFenetreAluLyon = lazy(() => import('../pages/reparation-fenetre-alu-lyon/page'));
const ReparationFenetreBoisLyon = lazy(() => import('../pages/reparation-fenetre-bois-lyon/page'));
const ReparationBaieVitreeLyon = lazy(() => import('../pages/reparation-baie-vitree-lyon/page'));
const RemplacementQuincaillerieFenetreLyon = lazy(() => import('../pages/remplacement-quincaillerie-fenetre-lyon/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const CommentCaMarche = lazy(() => import('../pages/comment-ca-marche/page'));

// City pages
const ReparationFenetreVilleurbanne = lazy(() => import('../pages/reparation-fenetre-villeurbanne/page'));
const ReparationFenetreVenissieux = lazy(() => import('../pages/reparation-fenetre-venissieux/page'));
const ReparationFenetreCaluire = lazy(() => import('../pages/reparation-fenetre-caluire-et-cuire/page'));
const ReparationFenetreSaintPriest = lazy(() => import('../pages/reparation-fenetre-saint-priest/page'));
const ReparationFenetreEcully = lazy(() => import('../pages/reparation-fenetre-ecully/page'));
const ReparationFenetreGivors = lazy(() => import('../pages/reparation-fenetre-givors/page'));
const ReparationFenetreFrancheville = lazy(() => import('../pages/reparation-fenetre-francheville/page'));
const ReparationFenetreCorbas = lazy(() => import('../pages/reparation-fenetre-corbas/page'));
const ReparationFenetreGenas = lazy(() => import('../pages/reparation-fenetre-genas/page'));
const ReparationFenetreMions = lazy(() => import('../pages/reparation-fenetre-mions/page'));
const ReparationFenetreBrignais = lazy(() => import('../pages/reparation-fenetre-brignais/page'));
const ReparationFenetreGrigny = lazy(() => import('../pages/reparation-fenetre-grigny/page'));
const ReparationFenetreVaulxEnVelin = lazy(() => import('../pages/reparation-fenetre-vaulx-en-velin/page'));
const ReparationFenetreBron = lazy(() => import('../pages/reparation-fenetre-bron/page'));
const ReparationFenetreRillieuxLaPape = lazy(() => import('../pages/reparation-fenetre-rillieux-la-pape/page'));
const ReparationFenetreMeyzieu = lazy(() => import('../pages/reparation-fenetre-meyzieu/page'));
const ReparationFenetreDecinesCharpieu = lazy(() => import('../pages/reparation-fenetre-decines-charpieu/page'));
const ReparationFenetreOullins = lazy(() => import('../pages/reparation-fenetre-oullins/page'));
const ReparationFenetreSainteFoyLesLyon = lazy(() => import('../pages/reparation-fenetre-sainte-foy-les-lyon/page'));
const ReparationFenetreTassinLaDemiLune = lazy(() => import('../pages/reparation-fenetre-tassin-la-demi-lune/page'));
const ReparationFenetreCharbonnieresLesBains = lazy(() => import('../pages/reparation-fenetre-charbonnieres-les-bains/page'));
const ReparationFenetreDardilly = lazy(() => import('../pages/reparation-fenetre-dardilly/page'));
const ReparationFenetreFeyzin = lazy(() => import('../pages/reparation-fenetre-feyzin/page'));
const ReparationFenetreSaintGenisLaval = lazy(() => import('../pages/reparation-fenetre-saint-genis-laval/page'));
const ReparationFenetreIrigny = lazy(() => import('../pages/reparation-fenetre-irigny/page'));
const ReparationFenetrePierreBenite = lazy(() => import('../pages/reparation-fenetre-pierre-benite/page'));
const ReparationFenetreLimonest = lazy(() => import('../pages/reparation-fenetre-limonest/page'));
const ReparationFenetreChampagneAuMontDOr = lazy(() => import('../pages/reparation-fenetre-champagne-au-mont-d-or/page'));
const ReparationFenetreCraponne = lazy(() => import('../pages/reparation-fenetre-craponne/page'));
const ReparationFenetreFontainesSurSaone = lazy(() => import('../pages/reparation-fenetre-fontaines-sur-saone/page'));
const ReparationFenetreChassieu = lazy(() => import('../pages/reparation-fenetre-chassieu/page'));
const ReparationFenetreNeuvilleSurSaone = lazy(() => import('../pages/reparation-fenetre-neuville-sur-saone/page'));
const ReparationFenetreVillefrancheSurSaone = lazy(() => import('../pages/reparation-fenetre-villefranche-sur-saone/page'));
const ReparationFenetreTarare = lazy(() => import('../pages/reparation-fenetre-tarare/page'));
const ReparationFenetreLArbresle = lazy(() => import('../pages/reparation-fenetre-l-arbresle/page'));
const ReparationFenetreMornant = lazy(() => import('../pages/reparation-fenetre-mornant/page'));
const ReparationFenetreChaponost = lazy(() => import('../pages/reparation-fenetre-chaponost/page'));
const ReparationFenetreSaintFons = lazy(() => import('../pages/reparation-fenetre-saint-fons/page'));
const ReparationFenetreSolaize = lazy(() => import('../pages/reparation-fenetre-solaize/page'));
const ReparationFenetreVernaison = lazy(() => import('../pages/reparation-fenetre-vernaison/page'));

// Blog pages
const ChoisirFenetresLyon = lazy(() => import('../pages/blog/choisir-fenetres-lyon/page'));
const FenetresDoubleVitrageLyon = lazy(() => import('../pages/blog/fenetres-double-vitrage-lyon/page'));
const IsolationThermiqueFenetresLyon = lazy(() => import('../pages/blog/isolation-thermique-fenetres-lyon/page'));
const EntretienFenetresPVCLyon = lazy(() => import('../pages/blog/entretien-fenetres-pvc-lyon/page'));
const SecuriteFenetresLyon = lazy(() => import('../pages/blog/securite-fenetres-lyon/page'));
const RenovationFenetresAnciennesLyon = lazy(() => import('../pages/blog/renovation-fenetres-anciennes-lyon/page'));
const FenetresSurMesureLyon = lazy(() => import('../pages/blog/fenetres-sur-mesure-lyon/page'));
const AidesFinancieresFenetresLyon = lazy(() => import('../pages/blog/aides-financieres-fenetres-lyon/page'));
const TendancesFenetres2025Lyon = lazy(() => import('../pages/blog/tendances-fenetres-2025-lyon/page'));
const PrixReparationFenetreLyon2025 = lazy(() => import('../pages/blog/prix-reparation-fenetre-lyon-2025/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/reparation-fenetre-pvc-lyon',
    element: <ReparationFenetrePVCLyon />,
  },
  {
    path: '/reparation-fenetre-alu-lyon',
    element: <ReparationFenetreAluLyon />,
  },
  {
    path: '/reparation-fenetre-bois-lyon',
    element: <ReparationFenetreBoisLyon />,
  },
  {
    path: '/reparation-baie-vitree-lyon',
    element: <ReparationBaieVitreeLyon />,
  },
  {
    path: '/remplacement-quincaillerie-fenetre-lyon',
    element: <RemplacementQuincaillerieFenetreLyon />,
  },
  {
    path: '/reparation-fenetre-villeurbanne',
    element: <ReparationFenetreVilleurbanne />,
  },
  {
    path: '/reparation-fenetre-venissieux',
    element: <ReparationFenetreVenissieux />,
  },
  {
    path: '/reparation-fenetre-caluire-et-cuire',
    element: <ReparationFenetreCaluire />,
  },
  {
    path: '/reparation-fenetre-saint-priest',
    element: <ReparationFenetreSaintPriest />,
  },
  {
    path: '/reparation-fenetre-ecully',
    element: <ReparationFenetreEcully />,
  },
  {
    path: '/reparation-fenetre-givors',
    element: <ReparationFenetreGivors />,
  },
  {
    path: '/reparation-fenetre-francheville',
    element: <ReparationFenetreFrancheville />,
  },
  {
    path: '/reparation-fenetre-corbas',
    element: <ReparationFenetreCorbas />,
  },
  {
    path: '/reparation-fenetre-genas',
    element: <ReparationFenetreGenas />,
  },
  {
    path: '/reparation-fenetre-mions',
    element: <ReparationFenetreMions />,
  },
  {
    path: '/reparation-fenetre-brignais',
    element: <ReparationFenetreBrignais />,
  },
  {
    path: '/reparation-fenetre-grigny',
    element: <ReparationFenetreGrigny />,
  },
  {
    path: '/reparation-fenetre-vaulx-en-velin',
    element: <ReparationFenetreVaulxEnVelin />,
  },
  {
    path: '/reparation-fenetre-bron',
    element: <ReparationFenetreBron />,
  },
  {
    path: '/reparation-fenetre-rillieux-la-pape',
    element: <ReparationFenetreRillieuxLaPape />,
  },
  {
    path: '/reparation-fenetre-meyzieu',
    element: <ReparationFenetreMeyzieu />,
  },
  {
    path: '/reparation-fenetre-decines-charpieu',
    element: <ReparationFenetreDecinesCharpieu />,
  },
  {
    path: '/reparation-fenetre-oullins',
    element: <ReparationFenetreOullins />,
  },
  {
    path: '/reparation-fenetre-sainte-foy-les-lyon',
    element: <ReparationFenetreSainteFoyLesLyon />,
  },
  {
    path: '/reparation-fenetre-tassin-la-demi-lune',
    element: <ReparationFenetreTassinLaDemiLune />,
  },
  {
    path: '/reparation-fenetre-charbonnieres-les-bains',
    element: <ReparationFenetreCharbonnieresLesBains />,
  },
  {
    path: '/reparation-fenetre-dardilly',
    element: <ReparationFenetreDardilly />,
  },
  {
    path: '/reparation-fenetre-feyzin',
    element: <ReparationFenetreFeyzin />,
  },
  {
    path: '/reparation-fenetre-saint-genis-laval',
    element: <ReparationFenetreSaintGenisLaval />,
  },
  {
    path: '/reparation-fenetre-irigny',
    element: <ReparationFenetreIrigny />,
  },
  {
    path: '/reparation-fenetre-pierre-benite',
    element: <ReparationFenetrePierreBenite />,
  },
  {
    path: '/reparation-fenetre-limonest',
    element: <ReparationFenetreLimonest />,
  },
  {
    path: '/reparation-fenetre-champagne-au-mont-d-or',
    element: <ReparationFenetreChampagneAuMontDOr />,
  },
  {
    path: '/reparation-fenetre-craponne',
    element: <ReparationFenetreCraponne />,
  },
  {
    path: '/reparation-fenetre-fontaines-sur-saone',
    element: <ReparationFenetreFontainesSurSaone />,
  },
  {
    path: '/reparation-fenetre-chassieu',
    element: <ReparationFenetreChassieu />,
  },
  {
    path: '/reparation-fenetre-neuville-sur-saone',
    element: <ReparationFenetreNeuvilleSurSaone />,
  },
  {
    path: '/reparation-fenetre-villefranche-sur-saone',
    element: <ReparationFenetreVillefrancheSurSaone />,
  },
  {
    path: '/reparation-fenetre-tarare',
    element: <ReparationFenetreTarare />,
  },
  {
    path: '/reparation-fenetre-l-arbresle',
    element: <ReparationFenetreLArbresle />,
  },
  {
    path: '/reparation-fenetre-mornant',
    element: <ReparationFenetreMornant />,
  },
  {
    path: '/reparation-fenetre-chaponost',
    element: <ReparationFenetreChaponost />,
  },
  {
    path: '/reparation-fenetre-saint-fons',
    element: <ReparationFenetreSaintFons />,
  },
  {
    path: '/reparation-fenetre-solaize',
    element: <ReparationFenetreSolaize />,
  },
  {
    path: '/reparation-fenetre-vernaison',
    element: <ReparationFenetreVernaison />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/comment-ca-marche',
    element: <CommentCaMarche />,
  },
  {
    path: '/blog/choisir-fenetres-lyon',
    element: <ChoisirFenetresLyon />,
  },
  {
    path: '/blog/fenetres-double-vitrage-lyon',
    element: <FenetresDoubleVitrageLyon />,
  },
  {
    path: '/blog/isolation-thermique-fenetres-lyon',
    element: <IsolationThermiqueFenetresLyon />,
  },
  {
    path: '/blog/entretien-fenetres-pvc-lyon',
    element: <EntretienFenetresPVCLyon />,
  },
  {
    path: '/blog/securite-fenetres-lyon',
    element: <SecuriteFenetresLyon />,
  },
  {
    path: '/blog/renovation-fenetres-anciennes-lyon',
    element: <RenovationFenetresAnciennesLyon />,
  },
  {
    path: '/blog/fenetres-sur-mesure-lyon',
    element: <FenetresSurMesureLyon />,
  },
  {
    path: '/blog/aides-financieres-fenetres-lyon',
    element: <AidesFinancieresFenetresLyon />,
  },
  {
    path: '/blog/tendances-fenetres-2025-lyon',
    element: <TendancesFenetres2025Lyon />,
  },
  {
    path: '/blog/prix-reparation-fenetre-lyon-2025',
    element: <PrixReparationFenetreLyon2025 />,
  },
  {
    path: '/mentions-legales',
    element: lazy(() => import('../pages/mentions-legales/page')),
  },
  {
    path: '/politique-confidentialite',
    element: lazy(() => import('../pages/politique-confidentialite/page')),
  },
  {
    path: '/cgu',
    element: lazy(() => import('../pages/cgv/page')),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
